// extracted by mini-css-extract-plugin
export default {"terms":"terms___OBTsC","checkout":"checkout___uS98u","buy_button":"buy_button___xPPj7","tab_title":"tab_title___IlagK","disabled_warn":"disabled_warn___JC4Pw"};